import { generateFileUrl } from "../utils/AzureStorageBlob";
import { externalUrl } from "../utils/commonFun";

const SponsorLogo = ({
  sponsorship,
  className,
}: {
  sponsorship: any;
  className?: string;
}) => {
  if (!sponsorship?.logo) return null;

  const website = externalUrl(sponsorship?.website);
  const logo = (
    <img
      src={generateFileUrl(sponsorship.logo)}
      alt={sponsorship?.company_name || "sponsor logo"}
      className={className}
    />
  );

  if (!website) return logo;

  return (
    <a href={website} target="_blank" rel="noopener noreferrer">
      {logo}
    </a>
  );
};

export default SponsorLogo;
